<!-- loading overlay -->
@if (_loading.value) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<!-- content -->
<div class="page-layout blank p-24" fusePerfectScrollbar>
  <!-- container -->
  <div class="container">
    <form [formGroup]='filterFormGroup'>
      <div class="main-widget">
        <div class="doc_title position-relative mat-blue-600-bg fx-row fx-justify-space-between fx-items-center">
          <div class="fx-column fx-justify-start fx-items-start">
            <span class="h2">{{'Seleziona il periodo di confronto' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="ranges">
        <div class="input-group fx-row fx-wrap fx-justify-space-between fx-items-stretch fx-sm-column fx-sm-wrap fx-xs-column fx-xs-wrap" style="gap: 30px">
          <div class="col fx-row fx-wrap fx-sm-column fx-sm-wrap fx-xs-column fx-xs-wrap" style="gap: 30px">
            <!-- Comparison type -->
            <form-input-viewer [formInputDefinition]='fileterFields.get("comparison_type")' [formGroup]='filterFormGroup' formControlKey='comparison_type' class="fx-flex"></form-input-viewer>
            <!-- Filter type -->
            <form-input-viewer [formInputDefinition]='fileterFields.get("filter_type")' [formGroup]='filterFormGroup' formControlKey='filter_type' class="fx-flex"></form-input-viewer>
            <!-- Tipo fatturato -->
            <form-input-viewer [formInputDefinition]='fileterFields.get("tipo_fatturato")' [formGroup]='filterFormGroup' formControlKey='tipo_fatturato' class="fx-flex"></form-input-viewer>
            <!-- Sort type -->
            <form-input-viewer [formInputDefinition]='fileterFields.get("sort_type")' [formGroup]='filterFormGroup' formControlKey='sort_type' class="fx-flex"></form-input-viewer>
            <!-- Include returns -->
            <!--<form-input-viewer [formInputDefinition]='fileterFields.get("include_returns")' [formGroup]='filterFormGroup' formControlKey='include_returns' class="fx-flex"></form-input-viewer>-->
          </div>
          <!-- col dates -->
          <div class="col fx-sm-column fx-sm-wrap fx-xs-column fx-xs-wrap">
            <div class="fx-row fx-wrap fx-sm-row fx-sm-wrap fx-xs-row fx-xs-wrap" style="gap: 30px">
              <!-- Start Month -->
              <mat-form-field>
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="picker1" [formControlName]="'from_date'" (dateChange)='onChangeDateFrom($event, "to_date")'>
                <mat-datepicker-toggle matSuffix [for]="picker1">
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              <!-- End Month -->
              <mat-form-field>
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="picker2" [max]='max' [min]='min' [formControlName]="'to_date'">
                <mat-datepicker-toggle matSuffix [for]="picker2">
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>


            @if (isCustomComparison) {
              <div class="fx-row fx-wrap fx-sm-row fx-sm-wrap fx-xs-row fx-xs-wrap" style="gap: 30px">
                <!-- Start Month -->
                <mat-form-field>
                  <mat-label>Choose a date</mat-label>
                  <input matInput [matDatepicker]="picker3" [formControlName]="'from_date_comparison'" (dateChange)='onChangeDateFrom($event, "to_date_comparison")'>
                  <mat-datepicker-toggle matSuffix [for]="picker3">
                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
                <!-- End Month -->
                <mat-form-field>
                  <mat-label>Choose a date</mat-label>
                  <input matInput [matDatepicker]="picker4" [max]='maxComparison' [min]='minComparison' [formControlName]="'to_date_comparison'">
                  <mat-datepicker-toggle matSuffix [for]="picker4">
                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                </mat-form-field>
              </div>
            }
          </div>
        </div>

        <!-- advanced filter fields -->
        <div class="dialog-filters" (click)='openFilters()'>Ricerca avanzata @if (numFilters) {
          <span class="num_filters">({{numFilters}} {{numFilters > 1 ? 'Filtri Attivi' : 'Filtro Attivo'}})</span>
        }</div>
        <!-- enabled filters -->
        <div class="enabled_filters">
          <mat-chip-set>
            @for (enabledFilter of enabledFilters; track enabledFilter) {
              <mat-chip>
                {{ enabledFilter.label }} <mat-icon (click)='removeFilter(enabledFilter.value)'>cancel</mat-icon>
              </mat-chip>
            }
          </mat-chip-set>
        </div>
        @if (_showCostSwitch) {
          <div class="input-groups fx-justify-start fx-items-center">
            <mat-slide-toggle (toggleChange)="viewCost()">{{'Mostra costi partenze' | translate}}</mat-slide-toggle>
          </div>
        }
        <div class="main-widget" style="margin-top: 40px;">
          <div class="doc_title position-relative mat-blue-600-bg fx-row fx-justify-space-between fx-items-center">
            <div class="fx-column fx-justify-start fx-items-start">
              <span class="h3">{{'Seleziona i campi da raggruppare' | translate}}</span>
            </div>
          </div>
        </div>
        <div class="raggruppamenti" >
          <div class="selections-container">
            <h2>Raggruppamenti disponibili</h2>
            <div class="input-groups" >
              <form-input-viewer #groupsInput [formInputDefinition]='fileterFields.get("groups")' [formGroup]='filterFormGroup' formControlKey='groups' class="fx-flex"></form-input-viewer>
            </div>
          </div>
          <!-- chip list -->
          @if (selectedGroups.length > 0) {
            <div cdkDropList class="chip-list" cdkDropListOrientation="horizontal" (cdkDropListDropped)='drop($event)' [cdkDropListDisabled]="viewCostStatus">
              @for (group of selectedGroups; track group) {
                <div class="chip-item" cdkDrag>
                  {{ group && group.label }}
                  @if (!viewCostStatus) {
                    <mat-icon (click)='remove(group)'>cancel</mat-icon>
                  }
                </div>
              }
            </div>
          }
        </div>
        <!-- action -->
        <div class="action">
          <!-- REPORT -->
          <button [disabled]='(selectedGroups.length == 0) || !filterFormGroup.valid' mat-button color="accent" (click)='loadFirstGroup()'>
            <mat-icon>launch</mat-icon>
            {{'Genera report' | translate}}
          </button>
          <!-- FILE EXPORT -->
          <button [disabled]='(selectedGroups.length == 0) || !filterFormGroup.valid' class="file_btn" mat-button [matMenuTriggerFor]="menu">
            <mat-icon>get_app</mat-icon>
            Esporta su file
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)='generaFile("xls")'>Xls</button>
            <button mat-menu-item (click)='generaFile("csv")'>Csv</button>
          </mat-menu>
        </div>
      </div>
    </form>
    <!-- standard-->
    @if (!_loading.value && selectedGroups.length > 0 && report && report[selectedGroups[0].value] && !viewCostStatus) {
      <!-- header -->
      <div class="header-bi">
        <div class="column first">
          <div class="empty_space"></div>
          <div class="row">
            <div class="counter"></div>
            <div class="item">Item</div>
          </div>
          <div class="row">
            <div class="counter"></div>
            <div class="code">Codice</div>
            <div class="descr">Descrizione</div>
          </div>
        </div>
        <div class="column second">
          <div class="row">
            <span>{{ fromDate }} - {{ toDate }}</span>
          </div>
          <div class="row">
            <div class="num_participants">Numero partecipanti</div>
            <div class="totale_pratica">Totale pratica</div>
          </div>
          <div class="row">
            <div class="assoluto">Assoulto (Quantità)</div>
            <div class="assoluto">Assoluto (Euro)</div>
          </div>
          <div class="row totals">
            <div class="totale_pratica">{{ _totals['default_range']['total_participants'] || 0 }}</div>
            <div class="assoluto">{{ _totals['default_range']['total_amount'] || 0 | number:'1.2-2':'it-IT' }}</div>
          </div>
        </div>
        <div class="column third">
          <div class="row">
            @if (filterFormGroup.get("comparison_type").value != "none") {
              <span>{{ fromDateComparison }} - {{ toDateComparison }}</span>
            }
          </div>
          <div class="row">
            <div class="num_participants">Numero partecipanti</div>
            <div class="totale_pratica">Totale pratica</div>
          </div>
          <div class="row">
            <div class="assoluto">Assoulto (Quantità)</div>
            <div class="assoluto">Assoluto (Euro)</div>
          </div>
          <div class="row totals">
            <div class="totale_pratica">{{ _totals['comparison_range']['total_participants'] || 0 }}</div>
            <div class="assoluto">{{ _totals['comparison_range']['total_amount'] || 0 | number:'1.2-2':'it-IT' }}</div>
          </div>
        </div>
        <div class="column fourth">
          <div class="row">
            <span>Confronto</span>
          </div>
          <div class="row">
            <div class="num_participants">Numero partecipanti</div>
            <div class="totale_pratica">Totale pratica</div>
          </div>
          <div class="row">
            <div class="subrow">
              <div class="assoluto">Assoluto (assoluto)</div>
              <div class="percentuale">Percentuale<br/>(percentuale)</div>
            </div>
            <div class="subrow">
              <div class="assoluto">Assoluto (assoluto)</div>
              <div class="percentuale">Percentuale<br/>(percentuale)</div>
            </div>
          </div>
          <div class="row">
            <div class="subrow totals">
              <div class="assoluto">{{ (_totals['default_range']['total_participants'] || 0) - (_totals['comparison_range']['total_participants'] || 0) }}</div>
              <div class="percentuale">{{ participantPercentage | number:'1.2-2':'it-IT' }}</div>
            </div>
            <div class="subrow totals">
              <div class="assoluto">{{ (_totals['default_range']['total_amount'] || 0) - (_totals['comparison_range']['total_amount'] || 0) | number:'1.2-2':'it-IT' }}</div>
              <div class="percentuale">{{ totalAmountPercentage | number:'1.2-2':'it-IT' }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- body -->
      <ng-container
        [ngTemplateOutlet]='groupsTemplate'
				[ngTemplateOutletContext]='{
				dataset: report[selectedGroups[0].value]["dataset"]["items"],
				currentGroup: report[selectedGroups[0].value]["currentGroup"],
				nextGroup: report[selectedGroups[0].value]["nextGroup"],
				prevGroup: null}'
      ></ng-container>
    }

    <!-- template-->
    <ng-template #groupsTemplate let-dataset='dataset' let-currentGroup='currentGroup' let-prevGroup='prevGroup' let-nextGroup='nextGroup'>
      @if (!dataset || dataset && !dataset.length) {
        <div class="no-data">Nessun risultato trovato</div>
      }
      <!-- body -->
      <div [ngClass]='["body", (prevGroup != null) ? "with_prev_group" : "", currentGroup]'>
        @if ((prevGroup == null)) {
          <div class="group_divider" [class.is_first]='(prevGroup == null)'></div>
        }
        @for (item of dataset; track item; let i = $index; let first = $first) {
          @if (item) {
            @if (nextGroup !== null && prevGroup == null) {
              <mat-icon (click)='expand(i, item, nextGroup, currentGroup, prevGroup, 1)' [class.expanded]='expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]'>
                expand_more
              </mat-icon>
            }
            <!-- if is first group -->
            @if ((prevGroup == null)) {
              <div class="action">
                @if (_loadingNext.value) {
                  <div class="_loadingNext"></div>
                }
                <div class="column first">
                  <div class="row">
                    <div class="counter">{{ item['count'] }}</div>
                    <div class="code">{{ item | biextradecode }}</div>
                    <div class="descr" [matTooltip]='item | biextradecode:"description"'>
                      <span class="item_description">{{ item | biextradecode:'description' }}</span>
                    </div>
                  </div>
                </div>
                <div class="column second">
                  <div class="row">
                    <div class="num_participants">
                      {{ item['total_participants'] }}
                    </div>
                    <div class="totale_pratica">
                      {{ item['total_amount'] | currency:'EUR' }}
                    </div>
                  </div>
                </div>
                <div class="column third">
                  <div class="row">
                    <div class="num_participants">
                      @if (item["total_participants_comparison"]) {
                        {{ item['total_participants_comparison'] }}
                      }
                    </div>
                    <div class="totale_pratica">
                      {{ item['total_amount_comparison'] | currency:'EUR' }}
                    </div>
                  </div>
                </div>
                <div class="column fourth">
                  <div class="row">
                    <div class="subrow">
                      <div class="assoluto">{{ (item['total_participants'] - item['total_participants_comparison'] || 0) }}</div>
                      <div class="percentuale">
                        @if (item['total_participants_comparison'] && item['total_participants_comparison'] > 0) {
                          {{ item | bipercentage:'participants' | number:'1.2-2':'it-IT' }}
                        }
                      </div>
                    </div>
                    <div class="subrow">
                      <div class="assoluto">{{ (item['total_amount'] - item['total_amount_comparison'] || 0) | currency:'EUR' }}</div>
                      <div class="percentuale">
                        @if (item['total_amount_comparison'] > 0) {
                          {{ item | bipercentage:'amount' | number:'1.2-2':'it-IT' }}
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if ((prevGroup != null)) {
              <div class="row" [class.expanded]='expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]'>
                @if (first) {
                  <div class="sub-header">
                    <div class="column first">
                      <div class="counter"></div>
                      <div class="code">Codice</div>
                      <div class="descr">Descrizione</div>
                    </div>
                    <div class="column second">
                      <div class="num_participants">Num. partecipanti</div>
                      <div class="totale_pratica">Tot. pratica</div>
                    </div>
                    <div class="column third">
                      <div class="num_participants">Num. partecipanti</div>
                      <div class="totale_pratica">Tot. pratica</div>
                    </div>
                    <div class="column fourth">
                      <div class="subrow">
                        <div class="assoluto">Ass. part.</div>
                        <div class="percentuale">Perc. part.</div>
                      </div>
                      <div class="subrow">
                        <div class="assoluto">Ass. prat.</div>
                        <div class="percentuale">Perc. prat</div>
                      </div>
                    </div>
                  </div>
                }
                <div class="sub-data" [class.expanded]='expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]'>
                  @if (_loadingNext.value) {
                    <div class="_loadingNext"></div>
                  }
                  @if (nextGroup !== null) {
                    <mat-icon (click)='expand(i, item, nextGroup, currentGroup, prevGroup)'>
                      expand_more
                    </mat-icon>
                  }
                  <div class="column first">
                    <div class="counter">{{ item['count'] }}</div>
                    <div class="code">{{ item | biextradecode }}</div>
                    <div class="descr" [matTooltip]='item | biextradecode:"description"'>
                      <span class="item_description">{{ item | biextradecode:'description' }}</span>
                    </div>
                  </div>
                  <div class="column second">
                    <div class="num_participants">{{ item['total_participants'] }}</div>
                    <div class="totale_pratica">{{ item['total_amount'] | currency:'EUR' }}</div>
                  </div>
                  <div class="column third">
                    <div class="num_participants">
                      @if (item["total_participants_comparison"]) {
                        {{ item['total_participants_comparison'] }}
                      }
                    </div>
                    <div class="totale_pratica">{{ item['total_amount_comparison'] | currency:'EUR' }}</div>
                  </div>
                  <div class="column fourth">
                    <div class="row">
                      <div class="subrow">
                        <div class="assoluto">{{ (item['total_participants'] - item['total_participants_comparison'] || 0) }}</div>
                        <div class="percentuale">
                          @if (item['total_participants_comparison'] && item['total_participants_comparison'] > 0) {
                            {{ item | bipercentage:'participants' | number:'1.2-2':'it-IT' }}
                          }
                        </div>
                      </div>
                      <div class="subrow">
                        <div class="assoluto">{{ (item['total_amount'] - item['total_amount_comparison'] || 0) | currency:'EUR' }}</div>
                        <div class="percentuale">
                          @if (item['total_amount_comparison'] && item['total_amount_comparison'] > 0) {
                            {{ item | bipercentage:'amount' | number:'1.2-2':'it-IT' }}
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
          <!-- if next group -->
          @if (report && report[nextGroup] && report[nextGroup]["dataset"] && report[nextGroup]["dataset"][item["record_id"]] && item["record_id"] && expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]) {
            <ng-container
              [ngTemplateOutlet]='groupsTemplate'
							[ngTemplateOutletContext]='{
							dataset: report[nextGroup]["dataset"][item["record_id"]],
							currentGroup: report[nextGroup]["currentGroup"],
							nextGroup: report[nextGroup]["nextGroup"],
							prevGroup: report[nextGroup]["prevGroup"]}'
            ></ng-container>
          }
        }
      </div>
    </ng-template>
    <!-- END standard-->

    <!-- width cost-->
    @if (!_loading.value && selectedGroups.length > 0 && report && report[selectedGroups[0].value] && viewCostStatus) {
      <!-- header -->
      <div class="header-bi-cost">
        <div class="column first">
          <div class="empty_space"></div>
          <div class="row">
            <div class="counter"></div>
            <div class="item">Item</div>
          </div>
          <div class="row">
            <div class="counter"></div>
            <div class="code">Codice</div>
            <div class="descr">Descrizione</div>
          </div>
        </div>
        <div class="column second">
          <div class="row">
            <span>{{ fromDate }} - {{ toDate }}</span>
          </div>
          <div class="row">
            <div class="num_participants" matTooltip="{{'Numero Partecipanti' | translate}}">#</div>
            <div class="totale_pratica">Totale</div>
            <div class="cost">Costo</div>
            <div class="margin">Margine</div>
            <div class="margin-perc">%</div>
          </div>
          <div class="row">
            <div class="assoluto">Qty</div>
            <div class="totale_pratica">(Euro)</div>
            <div class="cost">(Euro)</div>
            <div class="margin">(Euro)</div>
            <div class="margin-perc">%</div>
          </div>
          <div class="row totals">
            <div class="num_participants" [matTooltip]="_totals['default_range']['total_participants']" >{{ _totals['default_range']['total_participants'] || 0 }}</div>
            <div class="totale_pratica" [matTooltip]="_totals['default_range']['total_amount']">{{ _totals['default_range']['total_amount'] || 0 | number:'1.2-2':'it-IT' }}</div>
            <div class="cost" [matTooltip]="_totals['default_range']['total_supplier_price']">{{ _totals['default_range']['total_supplier_price'] || 0 | number:'1.2-2':'it-IT' }}</div>
            <div class="margin" [matTooltip]="_totals['default_range']['total_profit']">{{ _totals['default_range']['total_profit'] || 0 | number:'1.2-2':'it-IT' }}</div>
            <div class="margin-perc" [matTooltip]="_totals['default_range']['total_profit_percent']">{{ _totals['default_range']['total_profit_percent'] || 0 | percent:'1.2-2':'it-IT' }}</div>
          </div>
        </div>
        <div class="column third">
          <div class="row">
            @if (filterFormGroup.get("comparison_type").value != "none") {
              <span>{{ fromDateComparison }} - {{ toDateComparison }}</span>
            }
          </div>
          <div class="row">
            <div class="num_participants" matTooltip="{{'Numero Partecipanti' | translate}}">#</div>
            <div class="totale_pratica">Totale</div>
            <div class="cost">Costo</div>
            <div class="margin">Margine</div>
            <div class="margin-perc">%</div>
          </div>
          <div class="row">
            <div class="assoluto">Qty</div>
            <div class="totale_pratica">(Euro)</div>
            <div class="cost">(Euro)</div>
            <div class="margin">(Euro)</div>
            <div class="margin-perc">%</div>
          </div>
          <div class="row totals">
            <div class="num_participants">{{ _totals['comparison_range']['total_participants'] || 0 }}</div>
            <div class="totale_pratica" [matTooltip]="_totals['comparison_range']['total_amount']" >{{ _totals['comparison_range']['total_amount'] || 0 | number:'1.2-2':'it-IT' }}</div>
            <div class="costo" [matTooltip]="_totals['comparison_range']['total_supplier_price']" >{{ _totals['comparison_range']['total_supplier_price'] || 0 | number:'1.2-2':'it-IT' }}</div>
            <div class="margine" [matTooltip]="_totals['comparison_range']['total_profit']" >{{ _totals['comparison_range']['total_profit'] || 0 | number:'1.2-2':'it-IT' }}</div>
            <div class="margin-percent" [matTooltip]="_totals['comparison_range']['total_profit_percent']" >{{ _totals['comparison_range']['total_profit_percent'] || 0 | percent:'1.2-2':'it-IT' }}</div>
          </div>
        </div>
        <div class="column fourth">
          <div class="row">
            <span>Confronto</span>
          </div>
          <div class="row ">
            <div class="num_participants">Partecipanti</div>
            <div class="totale_pratica">Totale</div>
            <div class="totale_pratica">Costo</div>
            <div class="totale_pratica">Margine</div>
            <!--<div class="totale_pratica">%</div>-->
          </div>
          <div class="row">
            <div class="subrow">
              <div class="assoluto">Assoluto (Euro)</div>
              <div class="percentuale">%</div>
            </div>
            <div class="subrow">
              <div class="assoluto">Assoluto (Euro)</div>
              <div class="percentuale">%</div>
            </div>
            <div class="subrow">
              <div class="assoluto">Assoluto (Euro)</div>
              <div class="percentuale">%</div>
            </div>
            <div class="subrow">
              <div class="assoluto">Assoluto (Euro)</div>
              <div class="percentuale">%</div>
            </div>
            <!--<div class="subrow">
            <div class="percentuale">%</div>
          </div>-->
        </div>
        <div class="row">
          <div class="subrow totals">
            <div class="assoluto">{{ (_totals['default_range']['total_participants'] || 0) - (_totals['comparison_range']['total_participants'] || 0) }}</div>
            <div class="percentuale">{{ participantPercentage | number:'1.2-2':'it-IT' }}</div>
          </div>
          <div class="subrow totals">
            <div class="assoluto">{{ (_totals['default_range']['total_amount'] || 0) - (_totals['comparison_range']['total_amount'] || 0) | number:'1.2-2':'it-IT' }}</div>
            <div class="percentuale">{{ totalAmountPercentage | number:'1.2-2':'it-IT' }}</div>
          </div>
          <div class="subrow totals">
            <div class="assoluto">{{ (_totals['default_range']['total_supplier_price'] || 0) - (_totals['comparison_range']['total_supplier_price'] || 0) | number:'1.2-2':'it-IT' }}</div>
            <div class="percentuale">{{ totalCostPercentage | number:'1.2-2':'it-IT' }}</div>
          </div>
          <div class="subrow totals">
            <div class="assoluto">{{ (_totals['default_range']['total_profit'] || 0) - (_totals['comparison_range']['total_profit'] || 0) | number:'1.2-2':'it-IT' }}</div>
            <div class="percentuale">{{ totalMarginPercentage | number:'1.2-2':'it-IT' }}</div>
          </div>
          <!--<div class="subrow totals">
          <div class="percentuale">{{ (_totals['default_range']['total_profit_percent'] || 0) - (_totals['comparison_range']['total_profit_percent'] || 0) | percent:'1.2-2':'it-IT' }}</div>
        </div>-->
      </div>
    </div>
  </div>
  <!-- body -->
  <ng-container
    [ngTemplateOutlet]='groupsCostTemplate'
                    [ngTemplateOutletContext]='{
				dataset: report[selectedGroups[0].value]["dataset"]["items"],
				currentGroup: report[selectedGroups[0].value]["currentGroup"],
				nextGroup: report[selectedGroups[0].value]["nextGroup"],
				prevGroup: null}'
  ></ng-container>
}

<!-- template-->
<ng-template #groupsCostTemplate let-dataset='dataset' let-currentGroup='currentGroup' let-prevGroup='prevGroup' let-nextGroup='nextGroup'>
  @if (!dataset || dataset && !dataset.length) {
    <div class="no-data">Nessun risultato trovato</div>
  }
  <!-- body -->
  <div [ngClass]='["body-cost", (prevGroup != null) ? "with_prev_group" : "", currentGroup]'>
    @if ((prevGroup == null)) {
      <div class="group_divider" [class.is_first]='(prevGroup == null)'></div>
    }
    @for (item of dataset; track item; let i = $index; let first = $first) {
      @if (item) {
        @if (nextGroup !== null && prevGroup == null) {
          <mat-icon (click)='expand(i, item, nextGroup, currentGroup, prevGroup, 1)' [class.expanded]='expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]'>
            expand_more
          </mat-icon>
        }
        <!-- if is first group -->
        @if ((prevGroup == null)) {
          <div class="action">
            @if (_loadingNext.value) {
              <div class="_loadingNext"></div>
            }
            <div class="column first">
              <div class="row">
                <div class="counter">{{ item['count'] }}</div>
                <div class="code">{{ item | biextradecode }}</div>
                <div class="descr" [matTooltip]='item | biextradecode:"description"'>
                  <span class="item_description">{{ item | biextradecode:'description' }}</span>
                </div>
              </div>
            </div>
            <div class="column second">
              <div class="row">
                <div class="num_participants" [matTooltip]="item['total_participants']">{{ item['total_participants'] }}</div>
                <div class="totale_pratica" [matTooltip]="item['total_amount']| currency:'EUR'">{{ item['total_amount'] | currency:'EUR' }}</div>
                <div class="cost" [matTooltip]="item['total_supplier_price'] | currency:'EUR'">{{ item['total_supplier_price'] | currency:'EUR' }}</div>
                <div class="margin" [matTooltip]="item['total_profit'] | currency:'EUR'">{{ item['total_profit'] | currency:'EUR' }}</div>
                <div class="margin-perc" [matTooltip]="item['total_profit_percent'] | percent:'1.2-2':'it-IT'">{{ item['total_profit_percent'] | percent:'1.2-2':'it-IT' }}</div>
              </div>
            </div>
            <div class="column third">
              <div class="row">
                <div class="num_participants">
                  @if (item["total_participants_comparison"]) {
                    {{ item['total_participants_comparison'] }}
                  }
                </div>
                <div class="totale_pratica" [matTooltip]="item['total_amount_comparison']">{{ item['total_amount_comparison'] | currency:'EUR' }}</div>
                <div class="cost" [matTooltip]="item['total_supplier_price_comparison'] | currency:'EUR'">{{ item['total_supplier_price_comparison'] | currency:'EUR' }}</div>
                <div class="margin" [matTooltip]="item['total_profit_comparison'] | currency:'EUR'">{{ item['total_profit_comparison'] | currency:'EUR' }}</div>
                <div class="margin-perc" [matTooltip]="item['total_profit_percent_comparison'] | percent:'1.2-2':'it-IT'">{{ item['total_profit_percent_comparison'] | percent:'1.2-2':'it-IT' }}</div>
              </div>
            </div>
            <div class="column fourth">
              <div class="row">
                <div class="subrow">
                  <div class="assoluto">{{ (item['total_participants'] - item['total_participants_comparison'] || 0) }}</div>
                  <div class="percentuale">
                    @if (item['total_participants_comparison'] && item['total_participants_comparison'] > 0) {
                      {{ item | bipercentage:'participants' | number:'1.2-2':'it-IT' }}
                    }
                  </div>
                </div>
                <div class="subrow">
                  <div class="assoluto">{{ (item['total_amount'] - item['total_amount_comparison'] || 0) | currency:'EUR' }}</div>
                  <div class="percentuale">
                    @if (item['total_amount_comparison'] > 0) {
                      {{ item | bipercentage:'amount' | number:'1.2-2':'it-IT' }}
                    }
                  </div>
                </div>
                <div class="subrow">
                  <div class="assoluto">{{ (item['total_supplier_price'] - item['total_supplier_price_comparison'] || 0) | currency:'EUR' }}</div>
                  <div class="percentuale">
                    @if (item['total_supplier_price_comparison'] > 0) {
                      {{ item | bipercentage:'supplier_price' | number:'1.2-2':'it-IT' }}
                    }
                  </div>
                </div>
                <div class="subrow">
                  <div class="assoluto">{{ (item['total_profit'] - item['total_profit_comparison'] || 0) | currency:'EUR' }}</div>
                  <div class="percentuale">
                    @if (item['total_profit_comparison'] > 0) {
                      {{ item | bipercentage:'profit' | number:'1.2-2':'it-IT' }}
                    }
                  </div>
                </div>
                <!--<div class="subrow">
                <div class="percentuale">
                  <ng-container *ngIf="item['total_profit_perc_comparison'] > 0">
                  {{ item | bipercentage:'percent' | number:'1.2-2':'it-IT' }}                                                </ng-container>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      }
      @if ((prevGroup != null)) {
        <div class="row" [class.expanded]='expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]'>
          @if (first) {
            <div class="sub-header">
              <div class="column first">
                <div class="counter"></div>
                <div class="code">Data</div>
                <div class="descr">Descrizione</div>
              </div>
              <div class="column second">
                <div class="num_participants" matTooltip="{{'Numero Partecipanti' | translate}}">#</div>
                <div class="totale_pratica">Totale</div>
                <div class="cost">Costo</div>
                <div class="margin">Margine</div>
                <div class="margin-perc">%</div>
              </div>
              <div class="column third">
                <div class="num_participants" matTooltip="{{'Numero Partecipanti' | translate}}">#</div>
                <div class="totale_pratica">Totale</div>
                <div class="cost">Costo</div>
                <div class="margin">Margine</div>
                <div class="margin-perc">%</div>
              </div>
              <div class="column fourth">
                <div class="subrow">
                  <div class="assoluto">Assoluto</div>
                  <div class="percentuale">%</div>
                </div>
                <div class="subrow">
                  <div class="assoluto">Assoluto</div>
                  <div class="percentuale">%</div>
                </div>
                <div class="subrow">
                  <div class="assoluto">Assoluto</div>
                  <div class="percentuale">%</div>
                </div>
                <div class="subrow">
                  <div class="assoluto">Assoluto</div>
                  <div class="percentuale">%</div>
                </div>
                <!--<div class="subrow">
                <div class="percentuale">%</div>
              </div>-->
            </div>
          </div>
        }
        <div class="sub-data" [class.expanded]='expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]'>
          @if (_loadingNext.value) {
            <div class="_loadingNext"></div>
          }
          @if (nextGroup !== null) {
            <mat-icon (click)='expand(i, item, nextGroup, currentGroup, prevGroup)'>
              expand_more
            </mat-icon>
          }
          <div class="column first">
            <div class="counter">{{ item['count'] }}</div>
            <div class="code">{{ item | biextradecode }}</div>
            <div class="descr" [matTooltip]='item | biextradecode:"description"'>
              <span class="item_description">{{ item | biextradecode:'description' }}</span>
            </div>
          </div>
          <div class="column second">
            <div class="num_participants" [matTooltip]="item['total_participants']" >{{ item['total_participants'] }}</div>
            <div class="totale_pratica" [matTooltip]="item['total_amount'] | currency:'EUR'">{{ item['total_amount'] | currency:'EUR' }}</div>
            <div class="cost" [matTooltip]="item['total_supplier_price'] | currency:'EUR'">{{ item['total_supplier_price'] | currency:'EUR' }}</div>
            <div class="margin" [matTooltip]="item['total_profit'] | currency:'EUR'">{{ item['total_profit'] | currency:'EUR' }}</div>
            <div class="margin-perc" [matTooltip]="item['total_profit_percent'] | percent:'1.2-2':'it-IT'">{{ item['total_profit_percent'] | percent:'1.2-2':'it-IT' }}</div>
          </div>
          <div class="column third">
            <div class="num_participants">
              @if (item["total_participants_comparison"]) {
                <ng-container [matTooltip]="item['total_participants_comparison']">
                  {{ item['total_participants_comparison'] }}
                </ng-container>
              }
            </div>
            <div class="totale_pratica" [matTooltip]="item['total_amount_comparison']">{{ item['total_amount_comparison'] | currency:'EUR' }}</div>
            <div class="cost" [matTooltip]="item['total_supplier_price_comparison']">{{ item['total_supplier_price_comparison'] | currency:'EUR' }}</div>
            <div class="margin" [matTooltip]="item['total_profit_comparison']">{{ item['total_profit_comparison'] | currency:'EUR' }}</div>
            <div class="margin-perc" [matTooltip]="item['total_profit_perc_comparison']">{{ item['total_profit_perc_comparison'] | percent:'1.2-2':'it-IT' }}</div>
          </div>
          <div class="column fourth">
            <div class="subrow">
              <div class="assoluto">{{ (item['total_participants'] - item['total_participants_comparison'] || 0) }}</div>
              <div class="percentuale">
                @if (item['total_participants_comparison'] && item['total_participants_comparison'] > 0) {
                  {{ item | bipercentage:'participants' | number:'1.2-2':'it-IT' }}
                }
              </div>
            </div>
            <div class="subrow">
              <div class="assoluto">{{ (item['total_amount'] - item['total_amount_comparison'] || 0) }}</div>
              <div class="percentuale">
                @if (item['total_amount_comparison'] && item['total_amount_comparison'] > 0) {
                  {{ item | bipercentage:'amount' | number:'1.2-2':'it-IT' }}
                }
              </div>
            </div>
            <div class="subrow">
              <div class="assoluto">{{ (item['total_supplier_price'] - item['total_supplier_price_comparison'] || 0) | currency:'EUR' }}</div>
              <div class="percentuale">
                @if (item['total_supplier_price_comparison'] && item['total_supplier_price_comparison'] > 0) {
                  {{ item | bipercentage:'supplier_price' | number:'1.2-2':'it-IT' }}
                }
              </div>
            </div>
            <div class="subrow">
              <div class="assoluto">{{ (item['total_profit'] - item['total_profit_comparison'] || 0) | currency:'EUR' }}</div>
              <div class="percentuale">
                @if (item['total_profit_comparison'] && item['total_profit_comparison'] > 0) {
                  {{ item | bipercentage:'profit' | number:'1.2-2':'it-IT' }}
                }
              </div>
            </div>
            <!--<div class="subrow">
            <div class="percentuale">
              <ng-container *ngIf="item['total_marigin_perc_comparison'] && item['total_profit_perc_comparison'] > 0">
              {{ item | bipercentage:'percent' | number:'1.2-2':'it-IT' }}                                                    </ng-container>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  }
}
<!-- if next group -->
@if (report && report[nextGroup] && report[nextGroup]["dataset"] && report[nextGroup]["dataset"][item["record_id"]] && item["record_id"] && expandedRecordGroups[currentGroup] && expandedRecordGroups[currentGroup][i] && expandedRecordGroups[currentGroup][i][item["record_id"]]) {
  <ng-container
    [ngTemplateOutlet]='groupsCostTemplate'
                                [ngTemplateOutletContext]='{
							dataset: report[nextGroup]["dataset"][item["record_id"]],
							currentGroup: report[nextGroup]["currentGroup"],
							nextGroup: report[nextGroup]["nextGroup"],
							prevGroup: report[nextGroup]["prevGroup"]}'
  ></ng-container>
}
}
</div>
</ng-template>
<!-- END width cost-->



<!-- paginator -->
@if (!_loading.value && selectedGroups.length > 0 && report && report[selectedGroups[0].value] && report[selectedGroups[0].value]["dataset"] && report[selectedGroups[0].value]["dataset"]["meta"] && report[selectedGroups[0].value]["dataset"]["meta"]["total"]) {
  <mat-paginator
    [pageSizeOptions]='[5, 10, 20, 50, 100, 200]'
    showFirstLastButtons
    [length]='report[selectedGroups[0].value]["dataset"]["meta"]["total"]'
    [pageSize]='report[selectedGroups[0].value]["dataset"]["meta"]["perPage"]'
    [pageIndex]='_pageIndex'
    (page)='onPageChanged($event)'
  ></mat-paginator>
}
</div>
</div>
